export default class SoundController {
    constructor() {
        // p5.soundFormats('wav');
        // this.laserSound = p5.loadSound('sounds/fire.wav');
        // this.bigExplosionSound = p5.loadSound('sounds/bangLarge.wav');
        // this.mediumExplosionSound = p5.loadSound('sounds/bangMedium.wav');
        // this.smallExplosionSound = p5.loadSound('sounds/bangSmall.wav');
        // this.thrustSound = p5.loadSound('sounds/thrust.wav');
    }

    laser() {
        // this.laserSound.setVolume(.3);
        // this.laserSound.play();
    }

    bigExplosion() {
        // this.bigExplosionSound.setVolume(.5);
        // this.bigExplosionSound.play();
    }

    mediumExplosion() {
        // this.mediumExplosionSound.setVolume(.5);
        // this.mediumExplosionSound.play();
    }

    smallExplosion() {
        // this.smallExplosionSound.setVolume(.5);
        // this.smallExplosionSound.play();
    }

    thrust() {
        // this.thrustSound.setVolume(.1);
        // this.thrustSound.play();
    }
}